/* ==========================================================================
   Bildgruppen der Produktgalerie - Leinenweberei Hoffmann, 03.09.2026
   Ersetzt die App "Easy Variant Images" (SpiceGems).

   Regel (identisch serverseitig in snippets/product-media.liquid):
     1. Jedes Bild, das bei irgendeiner Variante als Thumbnail hinterlegt ist,
        startet eine Gruppe.
     2. Eine Gruppe = Startbild + alle in den Medien folgenden Bilder bis zum
        naechsten Startbild.
     3. Bilder vor dem ersten Startbild sind Vorspann und immer sichtbar.
     4. Gefiltert wird nur bei mindestens zwei Gruppen.
     5. Eine Variante ohne eigenes Thumbnail erbt die Gruppe der naechst-
        gelegenen Variante mit Thumbnail innerhalb desselben Werts der ersten
        Option - erst rueckwaerts, dann vorwaerts. Findet sich dort keine,
        werden alle Bilder gezeigt.
     6. Bleibt die Gruppe beim Variantenwechsel gleich, wird die Galerie nicht
        angefasst (kein Zuruecksprigen beim Groessenwechsel).

   Ladeverhalten (03.09.2026 nachgezogen): ausgeblendete Bilder haben
   display:none und werden vom Browser deshalb nie geladen. Beim Farbwechsel
   begannen sie erst in dem Moment zu laden, in dem sie sichtbar wurden - die
   Galerie stand dann fuer einige hundert Millisekunden leer da. Dagegen drei
   Massnahmen: die Thumbnails der aktiven Gruppe werden sofort eager geladen,
   die Bilder der uebrigen Gruppen nach dem Seitenaufbau im Leerlauf mit
   niedriger Prioritaet vorgewaermt, und umgeschaltet wird erst, wenn das neue
   Startbild wirklich da ist (mit 700-ms-Notbremse).
   ========================================================================== */
(function () {
  'use strict';

  /* Waehrend carousel.reload() laeuft, ist die Galerie kurz ohne Flickity. Die
     Theme-Regel .product__media-list:not(.flickity-enabled) .product__media-item:not(.is-selected)
     blendet dann alles aus, weil Flickitys destroy() seine Klasse is-selected
     mitnimmt - die Galerie waere fuer diesen Moment leer. is-initial-selected
     ueberlebt destroy(), also halten wir daran das Startbild der Gruppe sichtbar. */
  function injectStyle() {
    if (document.getElementById('hf-media-groups-style')) return;
    var st = document.createElement('style');
    st.id = 'hf-media-groups-style';
    st.textContent = '.product__media-list:not(.flickity-enabled) .product__media-item.is-initial-selected{display:block}';
    document.head.appendChild(st);
  }

  /* Laedt dasselbe Bild noch einmal ueber ein loses Image-Objekt. srcset und
     sizes werden mitgenommen, damit der Browser exakt dieselbe Datei waehlt
     wie spaeter das echte <img> - sonst waere der Cache-Treffer weg. */
  function preloadOf(img, lowPriority) {
    var pre = new Image();
    if (lowPriority && 'fetchPriority' in pre) pre.fetchPriority = 'low';
    var sizes = img.getAttribute('sizes');
    var srcset = img.getAttribute('srcset');
    var src = img.getAttribute('src');
    if (sizes) pre.sizes = sizes;
    if (srcset) pre.srcset = srcset;
    if (src) pre.src = src;
    return pre;
  }

  function isLoaded(img) {
    return !!img && img.complete && img.naturalWidth > 0;
  }

  function setup(mediaEl) {
    if (mediaEl.getAttribute('data-hf-groups-init')) return;
    var dataEl = mediaEl.querySelector('[data-hf-media-groups]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    mediaEl.setAttribute('data-hf-groups-init', '1');
    injectStyle();

    var order = (data.order || []).map(String);
    var variants = data.variants || [];
    var carousel = mediaEl.querySelector('flickity-carousel');
    var formId = mediaEl.getAttribute('form-id');

    /* Startbilder: alle Varianten-Thumbnails, die in den Medien vorkommen */
    var isStart = {}, startCount = 0, i;
    for (i = 0; i < variants.length; i++) {
      var m = variants[i].m == null ? null : String(variants[i].m);
      if (m && order.indexOf(m) > -1 && !isStart[m]) { isStart[m] = true; startCount++; }
    }

    /* Medien-ID -> Gruppen-ID; null bedeutet Vorspann (immer sichtbar) */
    var groupOf = {}, cur = null;
    for (i = 0; i < order.length; i++) {
      if (isStart[order[i]]) cur = order[i];
      groupOf[order[i]] = cur;
    }

    function mainImg(id) {
      var el = mediaEl.querySelector('.product__media-item[data-media-id="' + id + '"] img');
      return el || null;
    }

    function groupOfIndex(idx) {
      if (idx < 0 || idx >= variants.length) return null;
      var own = variants[idx].m;
      if (own != null && isStart[String(own)]) return String(own);
      var val = variants[idx].o, k;
      for (k = idx - 1; k >= 0; k--) {
        if (variants[k].o === val && variants[k].m != null && isStart[String(variants[k].m)]) {
          return String(variants[k].m);
        }
      }
      for (k = idx + 1; k < variants.length; k++) {
        if (variants[k].o === val && variants[k].m != null && isStart[String(variants[k].m)]) {
          return String(variants[k].m);
        }
      }
      return null;
    }

    function indexOfVariant(id) {
      for (var k = 0; k < variants.length; k++) {
        if (String(variants[k].id) === String(id)) return k;
      }
      return -1;
    }

    /* Serverseitig gerenderte Gruppe ermitteln, damit der erste Wechsel richtig
       vergleicht. '*' heisst: es wird gerade nicht gefiltert. */
    var lastGroup = (function () {
      if (!mediaEl.querySelector('.product__media-item.is-group-hidden')) return '*';
      for (var k = 0; k < order.length; k++) {
        var el = mediaEl.querySelector('.product__media-item[data-media-id="' + order[k] + '"]');
        if (el && !el.classList.contains('is-group-hidden') && groupOf[order[k]] !== null) {
          return groupOf[order[k]];
        }
      }
      return '*';
    })();

    function swap(group, first) {
      var nodes = mediaEl.querySelectorAll('[data-media-id]');
      for (var n = 0; n < nodes.length; n++) {
        var el = nodes[n];
        var id = el.getAttribute('data-media-id');
        var g = groupOf[id];
        var hide = !(group === null || g === null || g === group);
        el.classList.toggle('is-group-hidden', hide);
        var sel = id === first;
        el.classList.toggle('is-selected', sel);
        el.classList.toggle('is-initial-selected', sel);
      }

      /* Flickity kennt seine Zellen nur vom Init und haelt sie in einem eigenen
         Slider-Container - reloadCells() sieht die ausgeblendeten Zellen daher
         gar nicht mehr. reload() zerstoert die Instanz, holt alle Medien in der
         Originalreihenfolge zurueck und baut sie mit dem cellSelector neu auf.
         Laeuft die Galerie noch gar nicht, reichen die Klassen: der cellSelector
         wird beim ersten Aufbau ohnehin ausgewertet. */
      if (!carousel || typeof carousel.reload !== 'function') return;
      if (String(carousel.className).indexOf('flickity-enabled') === -1) return;
      try {
        var p = carousel.reload();
        if (p && typeof p['catch'] === 'function') p['catch'](function () {});
      } catch (err) {}
    }

    /* Erst umschalten, wenn das neue Startbild geladen ist - sonst zeigt die
       Galerie waehrend des Flickity-Neuaufbaus eine leere Flaeche. */
    function whenReady(id, cb) {
      var img = mainImg(id);
      if (isLoaded(img)) { cb(); return; }
      if (!img) { cb(); return; }
      var done = false;
      var fire = function () { if (done) return; done = true; cb(); };
      var pre = preloadOf(img, false);
      pre.onload = fire;
      pre.onerror = fire;
      if (pre.complete) fire();
      setTimeout(fire, 700);
    }

    function apply(variantId) {
      if (startCount < 2) return;
      var group = groupOfIndex(indexOfVariant(variantId));
      var key = group === null ? '*' : group;
      if (key === lastGroup) return;
      lastGroup = key;
      var first = group !== null ? group : order[0];
      whenReady(first, function () {
        if (lastGroup !== key) return;   /* inzwischen weitergeklickt */
        swap(group, first);
      });
    }

    /* Die Thumbnails der aktiven Gruppe stehen auf Desktop immer im sichtbaren
       Bereich, sind im Theme aber loading="lazy". Der Browser holt sie deshalb
       erst nach dem ersten Layout - gemessen rund 900 ms nach Seitenaufruf,
       also deutlich nach dem Hauptbild. Dieses Skript laeuft als defer-Script
       schon vor DOMContentLoaded, das Umstellen auf eager holt sie damit rund
       400 ms frueher. Ausgeblendete Thumbnails bleiben lazy. */
    function eagerVisibleThumbs() {
      var list = mediaEl.querySelectorAll('.product__thumbnail-item:not(.is-group-hidden) img');
      for (var k = 0; k < list.length && k < 8; k++) {
        if (!isLoaded(list[k])) list[k].setAttribute('loading', 'eager');
      }
    }
    eagerVisibleThumbs();

    /* Nach dem Seitenaufbau im Leerlauf die Bilder der uebrigen Gruppen holen,
       damit der erste Farbwechsel nicht erst laden muss. Nur ab Tablet-Breite
       und nicht bei Datensparmodus oder langsamer Verbindung. */
    function warm() {
      var c = navigator.connection;
      if (c && (c.saveData || String(c.effectiveType || '').indexOf('2g') > -1)) return;
      if (window.innerWidth < 741) return;
      var k, img;
      var thumbs = mediaEl.querySelectorAll('.product__thumbnail-item img');
      for (k = 0; k < thumbs.length; k++) {
        if (!isLoaded(thumbs[k])) preloadOf(thumbs[k], true);
      }
      var starts = 0;
      for (k = 0; k < order.length && starts < 12; k++) {
        if (!isStart[order[k]]) continue;
        starts++;
        img = mainImg(order[k]);
        if (img && !isLoaded(img)) preloadOf(img, true);
      }
    }

    function scheduleWarm() {
      var go = function () {
        if (window.requestIdleCallback) window.requestIdleCallback(warm, { timeout: 3000 });
        else setTimeout(warm, 1200);
      };
      if (document.readyState === 'complete') go();
      else window.addEventListener('load', go);
    }
    scheduleWarm();

    function relevant(e) {
      if (formId && e.target && e.target.id === formId) return true;
      return document.querySelectorAll('product-media').length === 1;
    }

    /* Focals ProductMedia._onVariantChanged (theme.js) greift beim Wechsel
       selbst in die Galerie: es setzt alle .is-filtered aus seiner Alt-Tag-
       Logik neu - die hier leer ausgeht - und selektiert das Varianten-
       Thumbnail. Mit vorab gesetzter selectedVariantMediaId steigt die Methode
       sofort wieder aus. Der Listener haengt in der Capture-Phase an document
       und laeuft damit vor dem Listener am Formular. */
    document.addEventListener('variant:changed', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v || !relevant(e)) return;
      mediaEl.selectedVariantMediaId = v.featured_media ? v.featured_media.id : null;
    }, true);

    document.addEventListener('variant:changed', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v || !relevant(e)) return;
      apply(v.id);
    });
  }

  function boot() {
    var list = document.querySelectorAll('product-media');
    for (var i = 0; i < list.length; i++) setup(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
